import { useDispatch, useSelector } from 'react-redux';

import {
  legendModes,
  setLegendMode,
} from '@App/pages/Consumers/consumers.store';

import './consumers-legend.css';

const energyFormatter = new Intl.NumberFormat('nl-BE', {
  maximumFractionDigits: 0,
});

const legendValuesByMode = {
  [legendModes.RECEIVED_VS_DEMAND]: ['100%', '80%', '60%', '40%', '20%', '10%', '0%'],
  [legendModes.HEAT_RECEIVED_MUNICIPALITY]: maximum => [
    maximum, maximum * 0.8, maximum * 0.6, maximum * 0.4, maximum * 0.2, maximum * 0.1, 0,
  ],
  [legendModes.HEAT_RECEIVED_STAT_SECTOR]: maximum => [
    maximum, maximum * 0.8, maximum * 0.6, maximum * 0.4, maximum * 0.2, maximum * 0.1, 0,
  ],
};
const legendOptions = [
  { label: '% ontvangen vs vraag', value: legendModes.RECEIVED_VS_DEMAND },
  { label: 'Warmte ontvangen', value: legendModes.HEAT_RECEIVED },
];

function ConsumersLegend() {
  const dispatch = useDispatch();
  const selectedMode = useSelector(state => state.consumers.legendMode);
  const heatReceivedMaximums = useSelector(state => state.consumers.heatReceivedMaximum);
  const heatReceivedLegendMode = useSelector(state => state.consumers.heatReceivedLegendMode);
  const legendValues = selectedMode === legendModes.HEAT_RECEIVED
    ? legendValuesByMode[heatReceivedLegendMode](
        heatReceivedMaximums[heatReceivedLegendMode],
      )
    : legendValuesByMode[legendModes.RECEIVED_VS_DEMAND];
  const legendLabel = selectedMode === legendModes.HEAT_RECEIVED
    ? 'Warmte ontvangen (GWh/jaar)'
    : 'Percentage ontvangen combinatiesleutels';
  const legendUnit = selectedMode === legendModes.HEAT_RECEIVED ? 'GWh/jaar' : '%';
  const formatLegendValue = value => typeof value === 'number'
    ? energyFormatter.format(value / 1_000_000)
    : value.replace('%', '');

  return (
    <div className="consumers-legend">
      <div className="consumers-legend__switch" role="group" aria-label="Legendaweergave">
        {legendOptions.map(({ label, value }) => (
          <button
            className={`consumers-legend__switch-option${selectedMode === value ? ' consumers-legend__switch-option--selected' : ''}`}
            key={value}
            type="button"
            aria-pressed={selectedMode === value}
            onClick={() => dispatch(setLegendMode(value))}
          >
            {label}
          </button>
        ))}
      </div>
      <div
        className="consumers-legend__scale"
        role="img"
        aria-label={legendLabel}
      >
        <span className="consumers-legend__unit">{legendUnit}</span>
        <span className="consumers-legend__width-sizer" aria-hidden="true">
          <span>{formatLegendValue(legendValues[0])}</span>
          <i className="consumers-legend__tick" />
        </span>
        <div className="consumers-legend__gradient" aria-hidden="true" />
        <div className="consumers-legend__labels">
          {legendValues.map(value => (
            <div className="consumers-legend__label" key={value}>
              <span>{formatLegendValue(value)}</span>
              <i className="consumers-legend__tick" aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ConsumersLegend;
